<div class="label">
  <label *ngIf="label"
         class="ppl-label"
         [class.is-required]="hasRequiredClass"
         [class.is-bold]="bold || hasChanges"
         [class.disabled]="disabled">
    <ng-container *ngTemplateOutlet="prependIconPart"></ng-container>
    {{label}}
  </label>

  <label *ngIf="labelContent"
         class="ppl-label">
    <ng-container *ngTemplateOutlet="prependIconPart"></ng-container>
    <ng-container *ngTemplateOutlet="labelContent"></ng-container>
  </label>

  <ppl-icon *ngIf="description"
            pplPopover
            [pplPopoverTooltip]="description"
            pplPopoverTooltipDirection="up"
            pplPopoverTooltipPreserveWhitespace="true"
            [pplPopoverTooltipHoverPreserve]="descriptionHoverPreserve"
            class="description"
            width="14px"
            height="14px"
            svgIcon="info-small-blue"></ppl-icon>

  <ppl-icon *ngIf="hasChanges"
            pplPopover
            pplPopoverTooltip="Undo Changes"
            i18n-pplPopoverTooltip="@@UndoChanges"
            pplPopoverTooltipDirection="up"
            class="form-changes"
            width="14px"
            height="14px"
            svgIcon="undo-action-darkblue"
            (click)="$event.stopPropagation(); undoChanges.emit()"></ppl-icon>

  <ppl-icon *ngIf="showClearSelection"
            pplPopover
            pplPopoverTooltip="Clear Selection"
            i18n-pplPopoverTooltip="@@ClearSelection"
            pplPopoverTooltipDirection="up"
            class="form-changes form-reset"
            width="14px"
            height="14px"
            svgIcon="trash_hover"
            (click)="$event.stopPropagation(); clearSelection.emit()"></ppl-icon>

  <div *ngIf="actionTemplate"
       class="label-action">
    <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
  </div>
</div>
<ng-content></ng-content>

<ng-container *ngIf="!showErrorsInTooltip && showErrors && hasErrorClass">
  <ng-container *ngTemplateOutlet="formControlErrorsTemplate"></ng-container>
</ng-container>

<span class="notice"
      *ngIf="notice || noticeContent">
  <ng-container *ngIf="notice">
    {{notice}}
  </ng-container>
  <ng-container *ngIf="noticeContent && !notice">
    <ng-template [ngTemplateOutlet]="noticeContent"></ng-template>
  </ng-container>
</span>

<div *ngIf="showErrorsTooltip"
     #errorsTooltip
     [style.width.px]="0"
     [style.height.px]="0"
     [pplPopover]="errorsTooltipPopover"
     [pplPopoverEvent]="null"
     [pplPopoverAnchorRect]="errorsTooltipPopoverAnchorRect"></div>

<ng-template #errorsTooltipPopover>
  <ppl-popover-tooltip type="error">
    <ng-container *ngTemplateOutlet="formControlErrorsTemplate"></ng-container>
  </ppl-popover-tooltip>
</ng-template>

<ng-template #formControlErrorsTemplate>
  <ppl-form-control-errors [errors]="control ? control.errors : errors"
                           [customErrorMessages]="customErrorMessages"></ppl-form-control-errors>
</ng-template>

<ng-template #prependIconPart>
  <ppl-icon *ngIf="prependIcon"
            class="prepend-icon"
            [svgIcon]="prependIcon"
            width="16px"
            height="16px"></ppl-icon>
</ng-template>
